export interface ISector {
  id: number;
  name: string;
  derived: boolean;
}

export class Sector implements ISector {
  constructor(
    public id: number,
    public name: string,
    public derived: boolean,
  ) {}
}
